const tFooterRoot = 'common.footer.';

export const contactUs = `${tFooterRoot}contactMessage`;
export const companyType = `${tFooterRoot}companyType`;
export const identity = `${tFooterRoot}identity`;
